export default "__VITE_ASSET__B0hW4ur4__"